module.exports = __webpack_public_path__ + "static/media/calendar-no-header-icon-177x197.eaec0468.jpg";